"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LRUInMemoryAssignmentCache = exports.NonExpiringInMemoryAssignmentCache = exports.AssignmentCache = void 0;
const lru_cache_1 = require("./lru-cache");
const obfuscation_1 = require("./obfuscation");
class AssignmentCache {
    constructor(cacheInstance) {
        this.cache = cacheInstance;
    }
    hasLoggedAssignment(key) {
        // no cache key present
        if (!this.cache.has(this.getCacheKey(key))) {
            return false;
        }
        // the subject has been assigned to a different variation
        // than was previously logged.
        // in this case we need to log the assignment again.
        if (this.cache.get(this.getCacheKey(key)) !== (0, obfuscation_1.getMD5Hash)(key.variationKey)) {
            return false;
        }
        return true;
    }
    setLastLoggedAssignment(key) {
        this.cache.set(this.getCacheKey(key), (0, obfuscation_1.getMD5Hash)(key.variationKey));
    }
    getCacheKey({ subjectKey, flagKey, allocationKey }) {
        return [`subject:${subjectKey}`, `flag:${flagKey}`, `allocation:${allocationKey}`].join(';');
    }
}
exports.AssignmentCache = AssignmentCache;
/**
 * A cache that never expires.
 *
 * The primary use case is for client-side SDKs, where the cache is only used
 * for a single user.
 */
class NonExpiringInMemoryAssignmentCache extends AssignmentCache {
    constructor() {
        super(new Map());
    }
}
exports.NonExpiringInMemoryAssignmentCache = NonExpiringInMemoryAssignmentCache;
/**
 * A cache that uses the LRU algorithm to evict the least recently used items.
 *
 * It is used to limit the size of the cache.
 *
 * The primary use case is for server-side SDKs, where the cache is shared across
 * multiple users. In this case, the cache size should be set to the maximum number
 * of users that can be active at the same time.
 */
class LRUInMemoryAssignmentCache extends AssignmentCache {
    constructor(maxSize) {
        super(new lru_cache_1.LRUCache(maxSize));
    }
}
exports.LRUInMemoryAssignmentCache = LRUInMemoryAssignmentCache;
//# sourceMappingURL=assignment-cache.js.map